import { Component, Input, Output, EventEmitter, ViewChild, OnChanges, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { EdpSelectList } from "../../@models/edp-select-list";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { debounceTime, tap } from "rxjs/operators";
import { map, startWith } from "rxjs/operators";

const MILLISECONDS_DEBOUNCE = 300;

@Component({
    selector: "edp-select-searchable",
    templateUrl: "./edp-select-searchable.component.html",
    styleUrls: ["./edp-select-searchable.component.scss"],
})
export class EdpSelectSearchableComponent implements OnInit, OnChanges {
    @Input() options: EdpSelectList[] = [];
    @Input() selected: string;
    @Input() halfHeight: boolean;
    @Input() placeholder = "pt.edp.edponline.select_list.search";
    @Output() nextOptions = new EventEmitter<EdpSelectList>();
    @ViewChild(NgbDropdown, { static: true })
    private dropdown: NgbDropdown;
    public formSearch = new FormControl();
    public _optionList: Observable<EdpSelectList[]> = this.formSearch.valueChanges.pipe(
        debounceTime(MILLISECONDS_DEBOUNCE),
        startWith(""),
        map(value => (value ? this.filterOptions(value) : this.options))
    );

    ngOnInit() {
        this.formSearch.valueChanges.subscribe(value => {
            if (!value) {
                this.nextOptions.emit(null);
            } else if (!!value && !this.dropdown._open && value !== this.selected) {
                this.dropdown.open();
            }
        });
    }

    ngOnChanges() {
        const selectedOption = this.options.find(option => option.selected);
        if (selectedOption) {
            this.selected = selectedOption.text;
            this.formSearch.setValue(this.selected);
        }
    }

    removeAccents(str: string): string {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    private filterOptions(value: string): EdpSelectList[] {
        return this.options.filter(option => new RegExp(`^(${this.removeAccents(value)})`, "gi").test(this.removeAccents(option.text)));
    }

    selectFirstOption() {
        const { value } = this.formSearch;
        const options = value ? this.filterOptions(value) : this.options;
        if (options && options[0]) {
            this.onChangeOption(options[0]);
            this.closeDropdown();
        }
    }

    onChangeOption(option: EdpSelectList): void {
        this.selected = option.text;

        this._optionList.subscribe(options => {
            options.forEach(item => (item.selected = false));
        });
        option.selected = true;
        this.formSearch.setValue(option.text);
        this.nextOptions.emit(option);
    }

    closeDropdown() {
        this.dropdown.close();
    }

    onDropdownChanged(isOpen: boolean) {
        if (!isOpen && !this.selected) {
            this.formSearch.setValue("");
        } else if (!isOpen && this.selected) {
            this.formSearch.setValue(this.selected);
        }
    }
}
